var map = {
	"./action-reply-all.svg": "b1ae",
	"./action-reply.svg": "6149",
	"./add-square.svg": "d8f6",
	"./alarm-check.svg": "552f",
	"./alarm-off.svg": "fb78",
	"./alarm-sleep.svg": "4531",
	"./alarm.svg": "2854",
	"./alert-circle.svg": "e146",
	"./alert-exclamation-circle--filled.svg": "1366",
	"./alert-exclamation-circle.svg": "34df",
	"./alert-exclamation-rhomboid--filled.svg": "1e4c",
	"./alert-exclamation-rhomboid.svg": "c756",
	"./alert-exclamation-triangle--filled.svg": "9eb1",
	"./alert-exclamation-triangle.svg": "62ae",
	"./alert-information--filled.svg": "db0d",
	"./alert-information.svg": "74e7",
	"./alert-question-circle--filled.svg": "b89a",
	"./alert-question-circle.svg": "9da6",
	"./alert-question-square--filled.svg": "0c9a",
	"./alert-question-square.svg": "ab4b",
	"./alert-travel-map-flag--filled.svg": "49fa",
	"./alert-travel-map-flag.svg": "2ec2",
	"./api.svg": "0bc2",
	"./arrow-bent-down-left-rounded--filled.svg": "155e",
	"./arrow-bent-down-left-rounded.svg": "e4a5",
	"./arrow-bent-down-left-straight--filled.svg": "5571",
	"./arrow-bent-down-left-straight.svg": "98f4",
	"./arrow-bent-down-right-rounded--filled.svg": "42a5",
	"./arrow-bent-down-right-rounded.svg": "2942",
	"./arrow-bent-down-right-straight--filled.svg": "63c2",
	"./arrow-bent-down-right-straight.svg": "3ca6",
	"./arrow-bent-left-down-rounded--filled.svg": "69f1",
	"./arrow-bent-left-down-rounded.svg": "e6ed",
	"./arrow-bent-left-down-straight--filled.svg": "a77f",
	"./arrow-bent-left-down-straight.svg": "2f9d",
	"./arrow-bent-left-up-rounded--filled.svg": "c980",
	"./arrow-bent-left-up-rounded.svg": "d7a6",
	"./arrow-bent-left-up-straight--filled.svg": "2a7c",
	"./arrow-bent-left-up-straight.svg": "fdf3",
	"./arrow-bent-right-down-rounded--filled.svg": "e56a",
	"./arrow-bent-right-down-rounded.svg": "a257",
	"./arrow-bent-right-down-straight--filled.svg": "f939",
	"./arrow-bent-right-down-straight.svg": "226a",
	"./arrow-bent-right-up-rounded--filled.svg": "aaf5",
	"./arrow-bent-right-up-rounded.svg": "f8d9",
	"./arrow-bent-right-up-straight--filled.svg": "b929",
	"./arrow-bent-right-up-straight.svg": "e8ed",
	"./arrow-bent-up-left-rounded--filled.svg": "0fb8",
	"./arrow-bent-up-left-rounded.svg": "da82",
	"./arrow-bent-up-left-straight--filled.svg": "ff50",
	"./arrow-bent-up-left-straight.svg": "82af",
	"./arrow-bent-up-right-rounded--filled.svg": "db1e",
	"./arrow-bent-up-right-rounded.svg": "970d",
	"./arrow-bent-up-right-straight--filled.svg": "1443",
	"./arrow-bent-up-right-straight.svg": "e9ee",
	"./arrow-button-corner-left-bottom--filled.svg": "1d2f",
	"./arrow-button-corner-left-bottom.svg": "d613",
	"./arrow-button-corner-left-top--filled.svg": "7883",
	"./arrow-button-corner-left-top.svg": "0108",
	"./arrow-button-corner-right-bottom--filled.svg": "e928",
	"./arrow-button-corner-right-bottom.svg": "b760",
	"./arrow-button-corner-right-top--filled.svg": "3ded",
	"./arrow-button-corner-right-top.svg": "1e44",
	"./arrow-button-double-down--filled.svg": "8475",
	"./arrow-button-double-down.svg": "5c33",
	"./arrow-button-double-left--filled.svg": "63cc",
	"./arrow-button-double-left.svg": "7053",
	"./arrow-button-double-right--filled.svg": "1f34",
	"./arrow-button-double-right.svg": "ea64",
	"./arrow-button-double-up--filled.svg": "7dd8",
	"./arrow-button-double-up.svg": "d833",
	"./arrow-button-down--filled.svg": "6f4c",
	"./arrow-button-down.svg": "9dca",
	"./arrow-button-left--filled.svg": "6cb0",
	"./arrow-button-left.svg": "8c54",
	"./arrow-button-line-down--filled.svg": "4838",
	"./arrow-button-line-down.svg": "b048",
	"./arrow-button-line-left--filled.svg": "4d2c",
	"./arrow-button-line-left.svg": "0d37",
	"./arrow-button-line-right--filled.svg": "ecac",
	"./arrow-button-line-right.svg": "1f29",
	"./arrow-button-line-up--filled.svg": "99df",
	"./arrow-button-line-up.svg": "2cd1",
	"./arrow-button-right--filled.svg": "42b8",
	"./arrow-button-right.svg": "8848",
	"./arrow-button-up--filled.svg": "9ce2",
	"./arrow-button-up.svg": "cfb1",
	"./arrow-chevron-circle-down--filled.svg": "8531",
	"./arrow-chevron-circle-down.svg": "2eb0",
	"./arrow-chevron-circle-left--filled.svg": "10ea",
	"./arrow-chevron-circle-left.svg": "ea39",
	"./arrow-chevron-circle-right--filled.svg": "a3a3",
	"./arrow-chevron-circle-right.svg": "b7e7",
	"./arrow-chevron-circle-up--filled.svg": "3e20",
	"./arrow-chevron-circle-up.svg": "89e6",
	"./arrow-chevron-down.svg": "4064",
	"./arrow-chevron-left.svg": "2b72",
	"./arrow-chevron-right.svg": "15a1",
	"./arrow-chevron-up.svg": "069a",
	"./arrow-curvy-double-arrow-left--filled.svg": "43aa",
	"./arrow-curvy-double-arrow-left.svg": "8e4d",
	"./arrow-curvy-double-arrow-right--filled.svg": "9cd7",
	"./arrow-curvy-double-arrow-right.svg": "8635",
	"./arrow-curvy-double-left--filled.svg": "e48c",
	"./arrow-curvy-double-left.svg": "78b2",
	"./arrow-curvy-double-right--filled.svg": "2dd7",
	"./arrow-curvy-double-right.svg": "3f57",
	"./arrow-curvy-vertical--filled.svg": "54b0",
	"./arrow-curvy-vertical.svg": "612b",
	"./arrow-data-transfer-diagonal--filled.svg": "9b38",
	"./arrow-data-transfer-diagonal-circle--filled.svg": "9c3d",
	"./arrow-data-transfer-diagonal-circle.svg": "f881",
	"./arrow-data-transfer-diagonal-square--filled.svg": "997d",
	"./arrow-data-transfer-diagonal-square.svg": "eac9",
	"./arrow-data-transfer-diagonal.svg": "4c09",
	"./arrow-data-transfer-horizontal--filled.svg": "febb",
	"./arrow-data-transfer-horizontal-circle--filled.svg": "a1c9",
	"./arrow-data-transfer-horizontal-circle.svg": "084c",
	"./arrow-data-transfer-horizontal-square--filled.svg": "43e4",
	"./arrow-data-transfer-horizontal-square.svg": "4f96",
	"./arrow-data-transfer-horizontal.svg": "5290",
	"./arrow-data-transfer-vertical--filled.svg": "a118",
	"./arrow-data-transfer-vertical-circle--filled.svg": "6cf2",
	"./arrow-data-transfer-vertical-circle.svg": "a466",
	"./arrow-data-transfer-vertical-square--filled.svg": "1467",
	"./arrow-data-transfer-vertical-square.svg": "65e1",
	"./arrow-data-transfer-vertical.svg": "1ca3",
	"./arrow-default-circle-down--filled.svg": "8444",
	"./arrow-default-circle-down.svg": "aa9f",
	"./arrow-default-circle-left--filled.svg": "845f",
	"./arrow-default-circle-left.svg": "5119",
	"./arrow-default-circle-right--filled.svg": "f0ef",
	"./arrow-default-circle-right.svg": "16a4",
	"./arrow-default-circle-up--filled.svg": "4850",
	"./arrow-default-circle-up.svg": "96be",
	"./arrow-default-corner-left-down--filled.svg": "1a8f",
	"./arrow-default-corner-left-down.svg": "654a",
	"./arrow-default-corner-left-up--filled.svg": "f7e6",
	"./arrow-default-corner-left-up.svg": "8f77",
	"./arrow-default-corner-right-down--filled.svg": "0d0e",
	"./arrow-default-corner-right-down.svg": "6b1c",
	"./arrow-default-corner-right-up--filled.svg": "075f",
	"./arrow-default-corner-right-up.svg": "0f35",
	"./arrow-default-crossover-down--filled.svg": "b685",
	"./arrow-default-crossover-down.svg": "7240",
	"./arrow-default-crossover-left--filled.svg": "4fc3",
	"./arrow-default-crossover-left.svg": "3e66",
	"./arrow-default-crossover-right-filled.svg": "a579",
	"./arrow-default-crossover-right.svg": "eb0e",
	"./arrow-default-crossover-up--filled.svg": "bf1c",
	"./arrow-default-crossover-up.svg": "b11f",
	"./arrow-default-diagonal-left--filled.svg": "c24b",
	"./arrow-default-diagonal-left.svg": "42d3",
	"./arrow-default-diagonal-right--filled.svg": "2a9c",
	"./arrow-default-diagonal-right.svg": "5fa7",
	"./arrow-default-double-diagonal--filled.svg": "7771",
	"./arrow-default-double-diagonal.svg": "e77d",
	"./arrow-default-double-horizontal.svg": "640f",
	"./arrow-default-down--filled.svg": "83ea",
	"./arrow-default-down.svg": "be47",
	"./arrow-default-left--filled.svg": "4e5a",
	"./arrow-default-left.svg": "c2f9",
	"./arrow-default-right--filled.svg": "9652",
	"./arrow-default-right.svg": "87c4",
	"./arrow-default-up--filled.svg": "b152",
	"./arrow-default-up.svg": "407b",
	"./arrow-divided-horizontal--filled.svg": "8529",
	"./arrow-divided-horizontal.svg": "259c",
	"./arrow-divided-vertical--filled.svg": "5a9c",
	"./arrow-divided-vertical.svg": "4be7",
	"./arrow-down.svg": "2fbf",
	"./arrow-expand-cross--filled.svg": "ec3a",
	"./arrow-expand-cross.svg": "dc71",
	"./arrow-expand-diagonal--filled.svg": "31c4",
	"./arrow-expand-diagonal-with-line--filled.svg": "57e9",
	"./arrow-expand-diagonal-with-line.svg": "edfe",
	"./arrow-expand-diagonal.svg": "9ff7",
	"./arrow-expand-horizontal--filled.svg": "8c11",
	"./arrow-expand-horizontal.svg": "bed7",
	"./arrow-expand-vertical--filled.svg": "8e54",
	"./arrow-expand-vertical-diamond--filled.svg": "77d7",
	"./arrow-expand-vertical-diamond.svg": "a64d",
	"./arrow-expand-vertical.svg": "3360",
	"./arrow-left.svg": "1e8e",
	"./arrow-loop--filled.svg": "6f66",
	"./arrow-loop-arrow--filled.svg": "30cc",
	"./arrow-loop-arrow.svg": "6a6f",
	"./arrow-loop-open--filled.svg": "b789",
	"./arrow-loop-open.svg": "5381",
	"./arrow-loop-triangle--filled.svg": "b71b",
	"./arrow-loop-triangle.svg": "1ae4",
	"./arrow-loop.svg": "4388",
	"./arrow-move-all-directions--filled.svg": "40cc",
	"./arrow-move-all-directions.svg": "e9bb",
	"./arrow-move-down--filled.svg": "9f63",
	"./arrow-move-down.svg": "4213",
	"./arrow-move-left--filled.svg": "560f",
	"./arrow-move-left-down--filled.svg": "a628",
	"./arrow-move-left-down.svg": "6323",
	"./arrow-move-left-up--filled.svg": "17eb",
	"./arrow-move-left-up.svg": "d7e3",
	"./arrow-move-left.svg": "f027",
	"./arrow-move-right--filled.svg": "92df",
	"./arrow-move-right-down--filled.svg": "94ae",
	"./arrow-move-right-down.svg": "f19b",
	"./arrow-move-right-up--filled.svg": "5b3d",
	"./arrow-move-right-up.svg": "32c8",
	"./arrow-move-right.svg": "6535",
	"./arrow-move-up--filled.svg": "e194",
	"./arrow-move-up.svg": "d892",
	"./arrow-nav-left.svg": "8997",
	"./arrow-nav-right.svg": "6e09",
	"./arrow-reload-horizontal--filled.svg": "0336",
	"./arrow-reload-horizontal.svg": "9355",
	"./arrow-reload-vertical--filled.svg": "a049",
	"./arrow-reload-vertical.svg": "e31f",
	"./arrow-right-thick.svg": "7271",
	"./arrow-right.svg": "1970",
	"./arrow-round-down--filled.svg": "c749",
	"./arrow-round-down.svg": "b6fd",
	"./arrow-round-left--filled.svg": "c0d4",
	"./arrow-round-left.svg": "5224",
	"./arrow-round-right--filled.svg": "b788",
	"./arrow-round-right.svg": "3c91",
	"./arrow-round-up--filled.svg": "45c4",
	"./arrow-round-up.svg": "67d2",
	"./arrow-scroll-connected-horizontal--filled.svg": "8ed9",
	"./arrow-scroll-connected-horizontal.svg": "eb4b",
	"./arrow-scroll-connected-vertical--filled.svg": "2260",
	"./arrow-scroll-connected-vertical.svg": "b37e",
	"./arrow-scroll-down--filled.svg": "5c48",
	"./arrow-scroll-down.svg": "9870",
	"./arrow-scroll-horizontal--filled.svg": "6912",
	"./arrow-scroll-horizontal.svg": "e6bf",
	"./arrow-scroll-point-diagonal-left--filled.svg": "4533",
	"./arrow-scroll-point-diagonal-left.svg": "a943",
	"./arrow-scroll-point-diagonal-right--filled.svg": "f8d0",
	"./arrow-scroll-point-diagonal-right.svg": "b1f9",
	"./arrow-scroll-point-horizontal--filled.svg": "8cf7",
	"./arrow-scroll-point-horizontal.svg": "31ab",
	"./arrow-scroll-point-vertical--filled.svg": "7783",
	"./arrow-scroll-point-vertical.svg": "e6d4",
	"./arrow-scroll-up--filled.svg": "2368",
	"./arrow-scroll-up.svg": "6853",
	"./arrow-scroll-vertical--filled.svg": "38e9",
	"./arrow-scroll-vertical.svg": "57a0",
	"./arrow-shrink-cross--filled.svg": "56bb",
	"./arrow-shrink-cross.svg": "04ce",
	"./arrow-shrink-diagonal--filled.svg": "d197",
	"./arrow-shrink-diagonal.svg": "1359",
	"./arrow-shrink-down--filled.svg": "a90b",
	"./arrow-shrink-down.svg": "1d50",
	"./arrow-shrink-horizontal--filled.svg": "0e10",
	"./arrow-shrink-horizontal.svg": "2dd6",
	"./arrow-shrink-up--filled.svg": "36cc",
	"./arrow-shrink-up.svg": "5fd6",
	"./arrow-shrink-vertical--filled.svg": "0ef1",
	"./arrow-shrink-vertical.svg": "e0e8",
	"./arrow-shuffle--filled.svg": "16a8",
	"./arrow-shuffle.svg": "fb63",
	"./arrow-split-vertical--filled.svg": "e4ac",
	"./arrow-split-vertical.svg": "50da",
	"./arrow-synchronise--filled.svg": "6195",
	"./arrow-synchronise-alert--filled.svg": "db13",
	"./arrow-synchronise-alert.svg": "eebd",
	"./arrow-synchronise.svg": "acb2",
	"./arrow-turn-down--filled.svg": "ba3d",
	"./arrow-turn-down.svg": "957d",
	"./arrow-turn-left--filled.svg": "e8c7",
	"./arrow-turn-left.svg": "a6c0",
	"./arrow-turn-right--filled.svg": "ac93",
	"./arrow-turn-right.svg": "60a6",
	"./arrow-turn-up--filled.svg": "1ee7",
	"./arrow-turn-up.svg": "ae38",
	"./arrow-up.svg": "dae7",
	"./attachment.svg": "4a37",
	"./audio-file-volume.svg": "26d4",
	"./award-medal.svg": "db30",
	"./bin.svg": "6e0b",
	"./book-closed-bookmark.svg": "7760",
	"./calendar-add.svg": "1d3c",
	"./calendar-cash.svg": "4de1",
	"./calendar-clock.svg": "2def",
	"./calendar-dotted.svg": "10df",
	"./calendar-refresh.svg": "6b0d",
	"./calendar.svg": "2be6",
	"./chat-bubble.svg": "b82a",
	"./chat.svg": "97b7",
	"./check-alternate.svg": "761c",
	"./check-circle.svg": "8e9d",
	"./chevron-left.svg": "c4ba",
	"./chevron-right.svg": "b8a1",
	"./close-alternate.svg": "00be",
	"./close.svg": "f62a",
	"./common-file-add.svg": "cc26",
	"./common-file-text-add.svg": "7601",
	"./communication-alert--filled.svg": "5ba9",
	"./communication-alert.svg": "31c2",
	"./communication-at--filled.svg": "deda",
	"./communication-at.svg": "fc1f",
	"./communication-attachment--filled.svg": "71cd",
	"./communication-attachment-file--filled.svg": "80d9",
	"./communication-attachment-file.svg": "0392",
	"./communication-attachment-image--filled.svg": "eb76",
	"./communication-attachment-image.svg": "cbd6",
	"./communication-attachment.svg": "6bf6",
	"./communication-chat--filled.svg": "3437",
	"./communication-chat.svg": "8095",
	"./communication-check--filled.svg": "d59a",
	"./communication-check.svg": "5f88",
	"./communication-conversation--filled.svg": "6c74",
	"./communication-conversation.svg": "98aa",
	"./communication-delete--filled.svg": "30d2",
	"./communication-delete.svg": "f598",
	"./communication-email-add--filled.svg": "e920",
	"./communication-email-add.svg": "8388",
	"./communication-email-check--filled.svg": "e703",
	"./communication-email-check.svg": "890d",
	"./communication-email-default--filled.svg": "d8cd",
	"./communication-email-default.svg": "2180",
	"./communication-email-notification--filled.svg": "108e",
	"./communication-email-notification.svg": "e2cf",
	"./communication-email-outbound--filled.svg": "b05e",
	"./communication-email-outbound.svg": "0d6c",
	"./communication-email-reply--filled.svg": "de09",
	"./communication-email-reply-all--filled.svg": "f03e",
	"./communication-email-reply-all.svg": "48c7",
	"./communication-email-reply.svg": "a561",
	"./communication-email-sent--filled.svg": "0f78",
	"./communication-email-sent.svg": "090d",
	"./communication-forward--filled.svg": "c072",
	"./communication-forward.svg": "e48a",
	"./communication-inbox--filled.svg": "42f2",
	"./communication-inbox.svg": "6e1b",
	"./communication-notification--filled.svg": "38fd",
	"./communication-notification.svg": "ffc2",
	"./communication-question--filled.svg": "c538",
	"./communication-question.svg": "85ae",
	"./communication-reply--filled.svg": "7676",
	"./communication-reply-all--filled.svg": "8427",
	"./communication-reply-all.svg": "9824",
	"./communication-reply.svg": "c436",
	"./communication-sent--filled.svg": "da24",
	"./communication-sent.svg": "b2bf",
	"./communication-shield--filled.svg": "40f2",
	"./communication-shield.svg": "3b67",
	"./communication-simple--filled.svg": "fcc3",
	"./communication-simple.svg": "982c",
	"./communication-writing--filled.svg": "7463",
	"./communication-writing.svg": "b9ac",
	"./content-book--filled.svg": "803a",
	"./content-book-page--filled.svg": "ccbc",
	"./content-book-page.svg": "c6a3",
	"./content-book-shelf--filled.svg": "415f",
	"./content-book-shelf.svg": "be59",
	"./content-book.svg": "f8d3",
	"./content-camera--filled.svg": "b964",
	"./content-camera.svg": "8be9",
	"./content-file--filled.svg": "dba6",
	"./content-file-add--filled.svg": "c1ff",
	"./content-file-add.svg": "1d16",
	"./content-file-bookmark--filled.svg": "00ee3",
	"./content-file-bookmark.svg": "761b",
	"./content-file-confirm--filled.svg": "405d",
	"./content-file-confirm.svg": "a802",
	"./content-file-copy--filled.svg": "8164",
	"./content-file-copy.svg": "c9da",
	"./content-file-delete--filled.svg": "b81e",
	"./content-file-delete.svg": "d78a",
	"./content-file-settings--filled.svg": "9ccd",
	"./content-file-settings.svg": "733e",
	"./content-file-text--filled.svg": "7cf4",
	"./content-file-text.svg": "10cd",
	"./content-file.svg": "5c60",
	"./content-flash--filled.svg": "60de",
	"./content-flash.svg": "bc3c",
	"./content-folder--filled.svg": "8af4",
	"./content-folder-add--filled.svg": "ea81",
	"./content-folder-add.svg": "3897",
	"./content-folder-delete--filled.svg": "6945",
	"./content-folder-delete.svg": "bb90",
	"./content-folder.svg": "b7a0",
	"./content-image--filled.svg": "ee15",
	"./content-image-2--filled.svg": "4a4c",
	"./content-image-2.svg": "181e",
	"./content-image-copy--filled.svg": "a4d5",
	"./content-image-copy.svg": "3cf5",
	"./content-image.svg": "d7f9",
	"./controls-next.svg": "db54",
	"./conversation-multilingual.svg": "0eca",
	"./copy-duplicate.svg": "1669",
	"./critical-triangle.svg": "56e4",
	"./dark-mode.svg": "0a6d",
	"./data-transfer.svg": "e067",
	"./database-voice.svg": "4cc1",
	"./database.svg": "ddad",
	"./diagram-all-direction-expand.svg": "b8e8",
	"./dollar.svg": "145b",
	"./download-thick-bottom.svg": "f0af",
	"./drawer-send.svg": "5b62",
	"./dynamics_int.svg": "4f42",
	"./email-action-send.svg": "c627",
	"./entertainment-controller--filled.svg": "7edf",
	"./entertainment-controller.svg": "076d",
	"./entertainment-controls-fast-forward--filled.svg": "1262",
	"./entertainment-controls-fast-forward.svg": "a2a2",
	"./entertainment-controls-next--filled.svg": "82af6",
	"./entertainment-controls-next.svg": "2b6c",
	"./entertainment-controls-pause--filled.svg": "f8c9",
	"./entertainment-controls-pause.svg": "1056",
	"./entertainment-controls-play--filled.svg": "1f1f",
	"./entertainment-controls-play-pause--filled.svg": "e3c1",
	"./entertainment-controls-play-pause.svg": "7247",
	"./entertainment-controls-play.svg": "b23f",
	"./entertainment-controls-previous--filled.svg": "2c5f",
	"./entertainment-controls-previous.svg": "14c7",
	"./entertainment-controls-rewind--filled.svg": "71b8",
	"./entertainment-controls-rewind.svg": "e85b",
	"./entertainment-movie--filled.svg": "ba38",
	"./entertainment-movie.svg": "5b4f",
	"./entertainment-music--filled.svg": "b664",
	"./entertainment-music.svg": "eb6b",
	"./entertainment-playlist--filled.svg": "2dc7",
	"./entertainment-playlist.svg": "3ddc",
	"./entertainment-volume-high--filled.svg": "8d64",
	"./entertainment-volume-high.svg": "1a3c",
	"./entertainment-volume-low--filled.svg": "e5c3",
	"./entertainment-volume-low.svg": "5a37",
	"./entertainment-volume-mute--filled.svg": "6f5e",
	"./entertainment-volume-mute.svg": "ff74",
	"./entertainment-volume-off--filled.svg": "3524",
	"./entertainment-volume-off.svg": "98b2",
	"./euro.svg": "b550",
	"./expand-less.svg": "255c",
	"./expand-more.svg": "592f",
	"./external-hyperlink.svg": "8dc5",
	"./eye-hide.svg": "fe8f",
	"./eye.svg": "4bfd",
	"./facebook.svg": "917d",
	"./faq.svg": "774f",
	"./feedback-award--filled.svg": "3b15",
	"./feedback-award.svg": "c261",
	"./feedback-crown--filled.svg": "7698",
	"./feedback-crown-circle--filled.svg": "c857",
	"./feedback-crown-circle.svg": "a604",
	"./feedback-crown-square--filled.svg": "6798",
	"./feedback-crown-square.svg": "0d48",
	"./feedback-crown.svg": "e9ee8",
	"./feedback-hand-bag--filled.svg": "7349",
	"./feedback-hand-bag.svg": "8851",
	"./feedback-hand-clock--filled.svg": "fd2a",
	"./feedback-hand-clock.svg": "4462",
	"./feedback-hand-coin--filled.svg": "4486",
	"./feedback-hand-coin.svg": "8a0f",
	"./feedback-hand-gift--filled.svg": "3482",
	"./feedback-hand-gift.svg": "b176",
	"./feedback-hand-heart--filled.svg": "4072",
	"./feedback-hand-heart.svg": "c915",
	"./feedback-hand-lock--filled.svg": "5df4",
	"./feedback-hand-lock.svg": "448d",
	"./feedback-hand-serving--filled.svg": "4616",
	"./feedback-hand-serving.svg": "d021",
	"./feedback-heart--filled.svg": "2607",
	"./feedback-heart-circle--filled.svg": "3a14",
	"./feedback-heart-circle.svg": "b5e4",
	"./feedback-heart-square--filled.svg": "a005",
	"./feedback-heart-square.svg": "991e",
	"./feedback-heart.svg": "9c78",
	"./feedback-implementation.svg": "0af6",
	"./feedback-smile-happy--filled.svg": "ebc5",
	"./feedback-smile-happy.svg": "5ebc",
	"./feedback-smile-neutral--filled.svg": "ae39",
	"./feedback-smile-neutral.svg": "4b39",
	"./feedback-smile-sad--filled.svg": "c50a",
	"./feedback-smile-sad.svg": "721c",
	"./feedback-star--filled.svg": "8a39",
	"./feedback-star-circle--filled.svg": "e7d2",
	"./feedback-star-circle.svg": "052c",
	"./feedback-star-half--filled.svg": "0ae0",
	"./feedback-star-half.svg": "4212",
	"./feedback-star-square--filled.svg": "8019",
	"./feedback-star-square.svg": "f1ce",
	"./feedback-star.svg": "6a25",
	"./feedback-thumb-down--filled.svg": "a14d",
	"./feedback-thumb-down-circle--filled.svg": "f680",
	"./feedback-thumb-down-circle.svg": "29fd",
	"./feedback-thumb-down-glove--filled.svg": "9f3b",
	"./feedback-thumb-down-glove.svg": "0852",
	"./feedback-thumb-down-square--filled.svg": "8202",
	"./feedback-thumb-down-square.svg": "e5b3",
	"./feedback-thumb-down.svg": "4ebb",
	"./feedback-thumb-up--filled.svg": "7e7b",
	"./feedback-thumb-up-circle--filled.svg": "c047",
	"./feedback-thumb-up-circle.svg": "f879",
	"./feedback-thumb-up-glove--filled.svg": "396c",
	"./feedback-thumb-up-glove.svg": "a886",
	"./feedback-thumb-up-square--filled.svg": "efee",
	"./feedback-thumb-up-square.svg": "4e6f",
	"./feedback-thumb-up.svg": "8d94",
	"./feedback-trophy--filled.svg": "896e",
	"./feedback-trophy.svg": "94b9",
	"./file-search.svg": "101a",
	"./file-text-done.svg": "41b2",
	"./file-text.svg": "9ad8",
	"./flash-off.svg": "0f91",
	"./flash.svg": "a2f5",
	"./folder-add.svg": "d946",
	"./folder-empty.svg": "ed29",
	"./freshdesk_int.svg": "54e0",
	"./full-chat.svg": "3066",
	"./full-faq.svg": "755d",
	"./full-ticket.svg": "99e4",
	"./gauge-dashboard.svg": "4fa2",
	"./genesys_purecloud_int.svg": "6b7d",
	"./gift.svg": "7fdc",
	"./graph-stats-ascend.svg": "3d83",
	"./headphones-customer-support-human.svg": "56c0",
	"./headphones.svg": "b980d",
	"./health-hospital--filled.svg": "bc74",
	"./health-hospital.svg": "a3a8",
	"./health-medical-bag--filled.svg": "4e85",
	"./health-medical-bag.svg": "ac1fb",
	"./health-medicine--filled.svg": "ee97",
	"./health-medicine.svg": "6b42",
	"./helpscout_int.svg": "22fe",
	"./helpshift_int.svg": "7a32",
	"./home.svg": "68cb",
	"./html.svg": "96fa",
	"./human-translation.svg": "6328",
	"./information-circle.svg": "4d31",
	"./inspect-code.svg": "df0f",
	"./instagram.svg": "07cf",
	"./intercom_int.svg": "8736",
	"./interface-add--filled.svg": "34ae",
	"./interface-add-circle--filled.svg": "fe58",
	"./interface-add-circle.svg": "a866",
	"./interface-add-square--filled.svg": "e477",
	"./interface-add-square.svg": "965f",
	"./interface-add.svg": "fbce",
	"./interface-bin--filled.svg": "bc67",
	"./interface-bin-diagonal--filled.svg": "36af",
	"./interface-bin-diagonal.svg": "9995",
	"./interface-bin-vertical--filled.svg": "983b",
	"./interface-bin-vertical.svg": "6f9f",
	"./interface-bin.svg": "52ff",
	"./interface-block--filled.svg": "353d",
	"./interface-block.svg": "ab95",
	"./interface-bookmark--filled.svg": "913e",
	"./interface-bookmark-stacked--filled.svg": "e677",
	"./interface-bookmark-stacked.svg": "c137",
	"./interface-bookmark.svg": "b6d9",
	"./interface-brightness-full--filled.svg": "24c7",
	"./interface-brightness-full.svg": "78d8",
	"./interface-brightness-half--filled.svg": "77e8",
	"./interface-brightness-half.svg": "acc1",
	"./interface-calendar--filled.svg": "398b",
	"./interface-calendar-alert--filled.svg": "fd1a",
	"./interface-calendar-alert.svg": "0320",
	"./interface-calendar-clock--filled.svg": "3cba",
	"./interface-calendar-clock.svg": "40c6",
	"./interface-calendar-day--filled.svg": "fa07",
	"./interface-calendar-day.svg": "ac938",
	"./interface-calendar-dot--filled.svg": "16dd",
	"./interface-calendar-dot.svg": "424f",
	"./interface-calendar-line--filled.svg": "c565",
	"./interface-calendar-line.svg": "d9a6",
	"./interface-calendar-week--filled.svg": "35a5",
	"./interface-calendar-week.svg": "7bef",
	"./interface-calendar.svg": "357e",
	"./interface-clock--filled.svg": "058e",
	"./interface-clock-reset--filled.svg": "725e",
	"./interface-clock-reset.svg": "f358",
	"./interface-clock-rewind--filled.svg": "c7bd",
	"./interface-clock-rewind.svg": "7492",
	"./interface-clock-stop-watch--filled.svg": "a4ee",
	"./interface-clock-stop-watch.svg": "97fe",
	"./interface-clock.svg": "dd66",
	"./interface-close.svg": "b399",
	"./interface-configurations-2-slides-horizontal--filled.svg": "9753",
	"./interface-configurations-2-slides-horizontal.svg": "27ff",
	"./interface-configurations-2-slides-vertical--filled.svg": "6bde",
	"./interface-configurations-2-slides-vertical.svg": "e245",
	"./interface-configurations-3-slides-horizontal--filled.svg": "1ed9",
	"./interface-configurations-3-slides-horizontal.svg": "f464",
	"./interface-configurations-3-slides-vertical--filled.svg": "7587",
	"./interface-configurations-3-slides-vertical.svg": "eef6",
	"./interface-configurations-toggle-horizontal--filled.svg": "4976",
	"./interface-configurations-toggle-horizontal.svg": "8be3",
	"./interface-configurations-toggle-vertical--filled.svg": "7f00",
	"./interface-configurations-toggle-vertical.svg": "0635",
	"./interface-confirm--filled.svg": "9a24",
	"./interface-confirm-circle--filled.svg": "0d0c",
	"./interface-confirm-circle.svg": "a1b4",
	"./interface-confirm-square--filled.svg": "c06a",
	"./interface-confirm-square.svg": "4638",
	"./interface-confirm.svg": "ee02",
	"./interface-copy.svg": "a18a",
	"./interface-customer-support-headphones--filled.svg": "17f9",
	"./interface-customer-support-headphones-small--filled.svg": "1828",
	"./interface-customer-support-headphones-small.svg": "eb5d",
	"./interface-customer-support-headphones.svg": "e41a",
	"./interface-customer-support-headset--filled.svg": "b8e2",
	"./interface-customer-support-headset.svg": "51c5",
	"./interface-customer-support-person--filled.svg": "fd97",
	"./interface-customer-support-person-mic--filled.svg": "2069",
	"./interface-customer-support-person-mic.svg": "c7e6",
	"./interface-customer-support-person.svg": "3dfd",
	"./interface-customer-support-phone--filled.svg": "b53c",
	"./interface-customer-support-phone.svg": "2bc9",
	"./interface-dark-mode--filled.svg": "3da4",
	"./interface-dark-mode.svg": "5758",
	"./interface-delete--filled.svg": "6a3f",
	"./interface-delete-circle--filled.svg": "6ea7",
	"./interface-delete-circle.svg": "c6fb",
	"./interface-delete-square--filled.svg": "0e78",
	"./interface-delete-square.svg": "8cc0",
	"./interface-delete.svg": "abfc",
	"./interface-download--filled.svg": "7cb2",
	"./interface-download.svg": "6f84",
	"./interface-duplicate--filled.svg": "1470",
	"./interface-duplicate.svg": "30d6",
	"./interface-edit--filled.svg": "b3c9",
	"./interface-edit.svg": "9b2a",
	"./interface-filter--filled.svg": "edc3",
	"./interface-filter-rounded--filled.svg": "ce28",
	"./interface-filter-rounded.svg": "d512",
	"./interface-filter.svg": "ad77",
	"./interface-gauge-cropped--filled.svg": "6725",
	"./interface-gauge-cropped.svg": "4c75",
	"./interface-gauge-full--filled.svg": "f1d9",
	"./interface-gauge-full.svg": "1457",
	"./interface-hide--filled.svg": "8af1",
	"./interface-hide.svg": "f83b",
	"./interface-hierarchy-loop--filled.svg": "59b8",
	"./interface-hierarchy-loop.svg": "4857",
	"./interface-hierarchy-network--filled.svg": "df9a",
	"./interface-hierarchy-network.svg": "252e",
	"./interface-hierarchy-pull--filled.svg": "1f19",
	"./interface-hierarchy-pull.svg": "29dd",
	"./interface-hierarchy-tree--filled.svg": "8d68",
	"./interface-hierarchy-tree.svg": "895c",
	"./interface-home--filled.svg": "953f",
	"./interface-home.svg": "a59b",
	"./interface-light-bulb--filled.svg": "6e02",
	"./interface-light-bulb-on--filled.svg": "e162",
	"./interface-light-bulb-on.svg": "166b",
	"./interface-light-bulb.svg": "6deb",
	"./interface-link--filled.svg": "e2a8",
	"./interface-link-broken--filled.svg": "ca4b",
	"./interface-link-broken.svg": "cae0",
	"./interface-link-external--filled.svg": "e0ce",
	"./interface-link-external-remove--filled.svg": "0502",
	"./interface-link-external-remove.svg": "c6b2",
	"./interface-link-external-square--filled.svg": "f1ba",
	"./interface-link-external-square.svg": "d084",
	"./interface-link-external.svg": "b815",
	"./interface-link-internal--filled.svg": "658a",
	"./interface-link-internal.svg": "2684",
	"./interface-link.svg": "8cd3",
	"./interface-loading-circle--filled.svg": "7eb7",
	"./interface-loading-circle.svg": "915c",
	"./interface-loading-dots--filled.svg": "b458",
	"./interface-loading-dots.svg": "cba1",
	"./interface-loading-lines--filled.svg": "3bd1",
	"./interface-loading-lines.svg": "b3fb",
	"./interface-loading-rectangles--filled.svg": "7187",
	"./interface-loading-rectangles.svg": "4fb5",
	"./interface-locked--filled.svg": "e4c7",
	"./interface-locked.svg": "70fe",
	"./interface-login--filled.svg": "7164",
	"./interface-login-circle--filled.svg": "f0bb",
	"./interface-login-circle.svg": "9f42",
	"./interface-login-square--filled.svg": "d17c",
	"./interface-login-square.svg": "6d17",
	"./interface-login.svg": "2262",
	"./interface-logout--filled.svg": "e83a",
	"./interface-logout-circle--filled.svg": "99cc",
	"./interface-logout-circle.svg": "8759",
	"./interface-logout-square--filled.svg": "8651",
	"./interface-logout-square.svg": "07a5",
	"./interface-logout.svg": "be53",
	"./interface-loop--filled.svg": "da6d",
	"./interface-loop-infinity--filled.svg": "794d",
	"./interface-loop-infinity.svg": "7e1e",
	"./interface-loop.svg": "ea0a",
	"./interface-menu-dots-horizontal--filled.svg": "d61c",
	"./interface-menu-dots-horizontal.svg": "8a7e",
	"./interface-menu-dots-vertical--filled.svg": "0f5b",
	"./interface-menu-dots-vertical.svg": "bbf8",
	"./interface-menu-hamburger--filled.svg": "aae5",
	"./interface-menu-hamburger.svg": "be83",
	"./interface-menu-stairs--filled.svg": "c02c",
	"./interface-menu-stairs.svg": "3717",
	"./interface-none.svg": "ef24",
	"./interface-notification--filled.svg": "f6b2",
	"./interface-notification-alert--filled.svg": "45a3",
	"./interface-notification-alert.svg": "b37b",
	"./interface-notification-badged--filled.svg": "798b",
	"./interface-notification-badged.svg": "5bac",
	"./interface-notification-silent--filled.svg": "7041",
	"./interface-notification-silent.svg": "f2ba",
	"./interface-notification.svg": "db23",
	"./interface-page-controller--filled.svg": "992d",
	"./interface-page-controller-center--filled.svg": "8a09",
	"./interface-page-controller-center.svg": "1477",
	"./interface-page-controller.svg": "4fc4",
	"./interface-placeholder.svg": "3f47",
	"./interface-remove--filled.svg": "39ac",
	"./interface-remove-circle--filled.svg": "8d8a",
	"./interface-remove-circle.svg": "9833",
	"./interface-remove-square--filled.svg": "ebce",
	"./interface-remove-square.svg": "8d08",
	"./interface-remove.svg": "7c88",
	"./interface-search--filled.svg": "d045",
	"./interface-search.svg": "5125",
	"./interface-security--filled.svg": "d433",
	"./interface-security-flat--filled.svg": "b451",
	"./interface-security-flat.svg": "904d",
	"./interface-security-shaped--filled.svg": "7406",
	"./interface-security-shaped.svg": "25e6",
	"./interface-security.svg": "0d62",
	"./interface-settings--filled.svg": "9ee7",
	"./interface-settings-shapes--filled.svg": "97fd",
	"./interface-settings-shapes.svg": "8783",
	"./interface-settings.svg": "41e8",
	"./interface-share--filled.svg": "c335",
	"./interface-share-blocked--filled.svg": "9e95",
	"./interface-share-blocked.svg": "ab4e",
	"./interface-share-correct--filled.svg": "7c7b",
	"./interface-share-correct.svg": "74e3",
	"./interface-share-delete--filled.svg": "39cb",
	"./interface-share-delete.svg": "31e7",
	"./interface-share-remove--filled.svg": "b91d",
	"./interface-share-remove.svg": "f75c",
	"./interface-share.svg": "fb3c",
	"./interface-show--filled.svg": "d735",
	"./interface-show.svg": "305f",
	"./interface-slide--filled.svg": "e23b",
	"./interface-slide.svg": "330e",
	"./interface-sort.svg": "72b5",
	"./interface-tab--filled.svg": "4a7a",
	"./interface-tab-opened.svg": "2f48",
	"./interface-tab.svg": "f0a8",
	"./interface-tag--filled.svg": "f289",
	"./interface-tag.svg": "c9e6",
	"./interface-unlocked--filled.svg": "cbfb",
	"./interface-unlocked.svg": "9df9",
	"./interface-upload--filled.svg": "46d1",
	"./interface-upload.svg": "1ade",
	"./interface-validation--filled.svg": "cb41",
	"./interface-validation.svg": "9a84",
	"./interface-whitespace.svg": "06dd",
	"./keyboard-wireless.svg": "1ac7",
	"./kustomer_int.svg": "9f2a",
	"./layout-dashboard.svg": "42c8",
	"./legal-briefcase.svg": "4988",
	"./legal-court--filled.svg": "e6be",
	"./legal-court.svg": "bc09",
	"./letter-envelop.svg": "a137",
	"./light-mode.svg": "efac",
	"./linkedin.svg": "b264",
	"./loading-line.svg": "9582",
	"./loading.svg": "a3be",
	"./location-pin.svg": "e1d8",
	"./lock.svg": "9f9d",
	"./login.svg": "4c2e",
	"./logout.svg": "38c1",
	"./loop-arrow.svg": "b60a",
	"./machine-translation.svg": "b2ba",
	"./magic-wand.svg": "8e27",
	"./mailchimp_int.svg": "2ce0",
	"./menu-expand.svg": "022c",
	"./messages-bubble-add.svg": "1a0c",
	"./messages-bubble-check.svg": "f951",
	"./messages-bubble-download.svg": "4efe",
	"./messages-bubble-forward-all.svg": "69cd",
	"./messages-bubble-forward.svg": "6384",
	"./messages-bubble-heart.svg": "ae24",
	"./messages-bubble-quotation.svg": "7f47",
	"./messages-bubble-square-add.svg": "bd9b",
	"./messages-bubble-text.svg": "1758",
	"./messages-bubble-typing.svg": "92a9",
	"./messages-bubble-upload.svg": "5692e",
	"./messages-bubble.svg": "178f",
	"./microphone.svg": "2941",
	"./module-apps.svg": "eb0b",
	"./money-dollar--filled.svg": "f070",
	"./money-dollar-circle--filled.svg": "e795",
	"./money-dollar-circle.svg": "8eee",
	"./money-dollar.svg": "2fd9",
	"./money-euro--filled.svg": "d2df",
	"./money-euro-circle--filled.svg": "c02f",
	"./money-euro-circle.svg": "8b04",
	"./money-euro.svg": "3e6a",
	"./money-gift--filled.svg": "1aa5",
	"./money-gift.svg": "88aa",
	"./money-hand-bag--filled.svg": "cf36",
	"./money-hand-bag.svg": "4135",
	"./money-hand-coin--filled.svg": "cd27",
	"./money-hand-coin.svg": "4b7f",
	"./money-hand-gift--filled.svg": "b902",
	"./money-hand-gift.svg": "216d",
	"./money-percentage-badge--filled.svg": "0093",
	"./money-percentage-badge.svg": "e35d",
	"./money-pound--filled.svg": "39d8",
	"./money-pound-circle--filled.svg": "86af",
	"./money-pound-circle.svg": "c1b5",
	"./money-pound.svg": "05fb",
	"./money-tag--filled.svg": "1854",
	"./money-tag.svg": "e9da",
	"./money-wallet--filled.svg": "37fa",
	"./money-wallet.svg": "4d80",
	"./more-horizontal.svg": "6f67",
	"./more-vertical.svg": "efaf",
	"./multi-actions-download.svg": "233c",
	"./multiple-actions-add.svg": "ed1f",
	"./multiple-actions-address.svg": "8883",
	"./multiple-actions-upload.svg": "953b",
	"./neuronal-network.svg": "f2d2",
	"./notes-add.svg": "e0ad",
	"./open-book.svg": "8e1e",
	"./paste.svg": "a26d",
	"./pause.svg": "e702",
	"./pencil.svg": "21bf",
	"./play.svg": "a9c4",
	"./programming-browser-search--filled.svg": "d78d",
	"./programming-browser-search.svg": "ebe7",
	"./programming-cloud--filled.svg": "20af",
	"./programming-cloud-check--filled.svg": "d1c3",
	"./programming-cloud-check.svg": "1b56",
	"./programming-cloud-download--filled.svg": "ebc6",
	"./programming-cloud-download.svg": "24aa",
	"./programming-cloud-upload--filled.svg": "8131",
	"./programming-cloud-upload.svg": "c890",
	"./programming-cloud.svg": "bd4d",
	"./programming-script--filled.svg": "423c",
	"./programming-script-2--filled.svg": "458e",
	"./programming-script-2.svg": "0c98",
	"./programming-script-close--filled.svg": "a284",
	"./programming-script-close.svg": "c03b",
	"./programming-script-open--filled.svg": "de32",
	"./programming-script-open.svg": "8d6d",
	"./programming-script.svg": "79cb",
	"./programming-sheet--filled.svg": "42e9",
	"./programming-sheet.svg": "5b6a",
	"./programming-web-windows--filled.svg": "74a8",
	"./programming-web-windows.svg": "6770",
	"./question-circle.svg": "c68e",
	"./rating-star-give.svg": "a7c7",
	"./refresh-three-quarter.svg": "bd0b",
	"./refresh.svg": "849d",
	"./remove-circle.svg": "d9f8",
	"./reporting-decrease--filled.svg": "dce3",
	"./reporting-decrease-graph--filled.svg": "4c25",
	"./reporting-decrease-graph.svg": "2f1d",
	"./reporting-decrease.svg": "37b9",
	"./reporting-graph-bar--filled.svg": "05a4",
	"./reporting-graph-bar-increase--filled.svg": "dc56",
	"./reporting-graph-bar-increase.svg": "a8dc",
	"./reporting-graph-bar.svg": "0f42",
	"./reporting-increase--filled.svg": "c6f9",
	"./reporting-increase-graph--filled.svg": "ba08",
	"./reporting-increase-graph.svg": "5376",
	"./reporting-increase.svg": "3fdf",
	"./reporting-money-graph--filled.svg": "8e19",
	"./reporting-money-graph.svg": "9e18",
	"./reporting-pie-chart--filled.svg": "3c66",
	"./reporting-pie-chart.svg": "11bb",
	"./reporting-signal--filled.svg": "a8d8",
	"./reporting-signal-square--filled.svg": "7756",
	"./reporting-signal-square.svg": "ea16",
	"./reporting-signal.svg": "5c85",
	"./reporting-user-increase--filled.svg": "8547",
	"./reporting-user-increase.svg": "656f",
	"./restart.svg": "498c",
	"./robot.svg": "9e82",
	"./salesforce_int.svg": "4b53",
	"./search.svg": "77aa",
	"./send-email.svg": "543f",
	"./send.svg": "2d1c",
	"./senior-editor.svg": "e109",
	"./settings-cog.svg": "c6a9",
	"./settings-slider.svg": "e975",
	"./share.svg": "da83",
	"./shield-check.svg": "76c4",
	"./shipping-box-2d--filled.svg": "5366",
	"./shipping-box-2d.svg": "7322",
	"./shipping-box-3d--filled.svg": "f874",
	"./shipping-box-3d.svg": "8296",
	"./shipping-truck--filled.svg": "b46b",
	"./shipping-truck.svg": "0011",
	"./single-action-download.svg": "72e4",
	"./single-action-upload.svg": "4a83",
	"./single-man-actions-upload.svg": "b726",
	"./single-man.svg": "2d94",
	"./single-neutral-actions-add.svg": "fb1b",
	"./sitecore_int.svg": "d9a3",
	"./social-profile-bubble.svg": "6902",
	"./speedometer-high.svg": "39da",
	"./speedometer-low.svg": "aa66",
	"./syncing.svg": "f9f4",
	"./tag.svg": "91b2",
	"./tags-add.svg": "0aab",
	"./tags-dollar.svg": "fa57",
	"./task-splitting.svg": "1afe",
	"./text-align-center--filled.svg": "25eb",
	"./text-align-center.svg": "6b04",
	"./text-align-justify--filled.svg": "9f17",
	"./text-align-justify.svg": "b989",
	"./text-align-left--filled.svg": "8b35",
	"./text-align-left.svg": "9e40",
	"./text-align-right--filled.svg": "b8b8",
	"./text-align-right.svg": "38bf",
	"./text-article--filled.svg": "44860",
	"./text-article.svg": "f8db",
	"./text-chinese--filled.svg": "ae0a",
	"./text-chinese.svg": "c74e",
	"./text-color-drop--filled.svg": "fbeb",
	"./text-color-drop.svg": "7cf3",
	"./text-columns--filled.svg": "41c3",
	"./text-columns.svg": "4182",
	"./text-comma.svg": "bafe",
	"./text-cursor--filled.svg": "3590",
	"./text-cursor-position--filled.svg": "b894",
	"./text-cursor-position.svg": "39b0",
	"./text-cursor.svg": "6e4c",
	"./text-eraser--filled.svg": "36cb",
	"./text-eraser.svg": "e182",
	"./text-formatting--filled.svg": "47cb",
	"./text-formatting-square--filled.svg": "abfc0",
	"./text-formatting-square.svg": "738e",
	"./text-formatting.svg": "3ec9",
	"./text-fullstop--filled.svg": "caec",
	"./text-fullstop.svg": "d3c4",
	"./text-indent-decrease--filled.svg": "ac20",
	"./text-indent-decrease.svg": "0e9d",
	"./text-indent-increase--filled.svg": "9143",
	"./text-indent-increase.svg": "af6b",
	"./text-list--filled.svg": "52b3",
	"./text-list-bullet--filled.svg": "9e7d",
	"./text-list-bullet--semi.svg": "00af",
	"./text-list-bullet.svg": "56e3",
	"./text-list.svg": "1309",
	"./text-menu-alternate--filled.svg": "070e",
	"./text-menu-alternate.svg": "af0c",
	"./text-paragraph--filled.svg": "c1ec",
	"./text-paragraph.svg": "7ce0",
	"./text-quote-curly--filled.svg": "cf29",
	"./text-quote-curly.svg": "1f15",
	"./text-quote-guillemots--filled.svg": "3c4a",
	"./text-quote-guillemots.svg": "f8bb",
	"./text-quote-handwritten--filled.svg": "e179",
	"./text-quote-handwritten.svg": "5e1a",
	"./text-quote-straight--filled.svg": "9347",
	"./text-quote-straight.svg": "d99c",
	"./text-roman--filled.svg": "6717",
	"./text-roman.svg": "631d",
	"./text-sigma--filled.svg": "f40f",
	"./text-sigma.svg": "eaa1",
	"./text-spacing-left--filled.svg": "30e8",
	"./text-spacing-left.svg": "c35e",
	"./text-spacing-right--filled.svg": "e607",
	"./text-spacing-right.svg": "69a1",
	"./text-style-bold--filled.svg": "7ee6",
	"./text-style-bold.svg": "6378",
	"./text-style-font-size--filled.svg": "5f0b",
	"./text-style-font-size.svg": "46aa",
	"./text-style-generic--filled.svg": "52c9",
	"./text-style-generic.svg": "73a4",
	"./text-style-italic--filled.svg": "133a",
	"./text-style-italic-off--filled.svg": "e391a",
	"./text-style-italic-off.svg": "9116",
	"./text-style-italic.svg": "c4a3",
	"./text-style-strikethrough--filled.svg": "d7c7",
	"./text-style-strikethrough-s--filled.svg": "2a67",
	"./text-style-strikethrough-s.svg": "f554",
	"./text-style-strikethrough.svg": "b97d",
	"./text-style-underlined--filled.svg": "5477",
	"./text-style-underlined.svg": "1c4d",
	"./text-subscript--filled.svg": "10fc",
	"./text-subscript.svg": "7971",
	"./text-superscript--filled.svg": "321b",
	"./text-superscript.svg": "54d3",
	"./text-wrap-bottom--filled.svg": "47ed",
	"./text-wrap-bottom--semi.svg": "8961",
	"./text-wrap-bottom.svg": "9e52",
	"./text-wrap-top--filled.svg": "4033",
	"./text-wrap-top--semi.svg": "6e59",
	"./text-wrap-top-left--filled.svg": "f70b",
	"./text-wrap-top-left--semi.svg": "583e",
	"./text-wrap-top-left.svg": "8add",
	"./text-wrap-top-right--filled.svg": "4f6c",
	"./text-wrap-top-right--semi.svg": "fa86",
	"./text-wrap-top-right.svg": "12c2",
	"./text-wrap-top.svg": "6c71",
	"./ticket.svg": "ef2a",
	"./time-clock-circle.svg": "d605",
	"./touch-id-lock.svg": "358d",
	"./translate.svg": "647b",
	"./translation-memories.svg": "a400",
	"./travel-airport-baggage--filled.svg": "0857",
	"./travel-airport-baggage.svg": "a8bc",
	"./travel-airport-flight--filled.svg": "f962",
	"./travel-airport-flight.svg": "5cab",
	"./travel-hotel-bell--filled.svg": "38e1",
	"./travel-hotel-bell.svg": "e0d2",
	"./travel-hotel-fitness--filled.svg": "e597",
	"./travel-hotel-fitness.svg": "59b1",
	"./travel-hotel-pets--filled.svg": "5041",
	"./travel-hotel-pets.svg": "8419",
	"./travel-hotel-spa--filled.svg": "b94d",
	"./travel-hotel-spa.svg": "bfa5",
	"./travel-location-compass--filled.svg": "63bb",
	"./travel-location-compass-circle--filled.svg": "6fbd",
	"./travel-location-compass-circle.svg": "b3a2",
	"./travel-location-compass.svg": "8a5a",
	"./travel-location-default--filled.svg": "16ccb",
	"./travel-location-default.svg": "63f3",
	"./travel-location-earth--filled.svg": "94f8",
	"./travel-location-earth.svg": "55d1",
	"./travel-location-map--filled.svg": "f8b2",
	"./travel-location-map.svg": "e746",
	"./travel-location-pin--filled.svg": "a5f9",
	"./travel-location-pin.svg": "6272",
	"./travel-places-beach--filled.svg": "723b",
	"./travel-places-beach.svg": "d9ad",
	"./travel-places-diamond--filled.svg": "7e03",
	"./travel-places-diamond.svg": "5d68",
	"./travel-places-hot-spring--filled.svg": "060c",
	"./travel-places-hot-spring.svg": "2f23",
	"./travel-places-street-sign--filled.svg": "f0e8",
	"./travel-places-street-sign.svg": "68cd",
	"./travel-places-theatre--filled.svg": "07d8",
	"./travel-places-theatre.svg": "c20d",
	"./travel-transport-bus--filled.svg": "15f0",
	"./travel-transport-bus.svg": "eaf8",
	"./travel-transport-plane--filled.svg": "3532",
	"./travel-transport-plane.svg": "b3a3",
	"./twitter.svg": "1e1f",
	"./unbabel-anonymization-human.svg": "f586",
	"./unbabel-apps--filled.svg": "2b46",
	"./unbabel-apps-remove--filled.svg": "b070",
	"./unbabel-apps-remove.svg": "3da1",
	"./unbabel-apps.svg": "99ff",
	"./unbabel-channels--filled.svg": "7ff3",
	"./unbabel-channels.svg": "4c61",
	"./unbabel-check-pen--filled.svg": "9cbe",
	"./unbabel-check-pen.svg": "86a0",
	"./unbabel-file-bookmark.svg": "5168",
	"./unbabel-file-folder.svg": "d9c9",
	"./unbabel-gauge-dashboard.svg": "2a49",
	"./unbabel-high-risk.svg": "3c1f",
	"./unbabel-human-translation.svg": "1824",
	"./unbabel-integrations-squared.svg": "cc23",
	"./unbabel-integrations.svg": "aa05",
	"./unbabel-kpi.svg": "6bc2",
	"./unbabel-language-pairs.svg": "a72f",
	"./unbabel-logo-circle.svg": "c989",
	"./unbabel-logo-default.svg": "438d",
	"./unbabel-logo-square.svg": "d787",
	"./unbabel-logo.svg": "5136",
	"./unbabel-module-apps--filled.svg": "eddb",
	"./unbabel-module-apps.svg": "e263",
	"./unbabel-modules.svg": "406a",
	"./unbabel-pipeline.svg": "bf91",
	"./unbabel-product.svg": "408a9",
	"./unbabel-projects.svg": "4064a",
	"./unbabel-reporting.svg": "539d",
	"./unbabel-secure.svg": "c838",
	"./unbabel-senior-editor.svg": "ce61",
	"./unbabel-sparkles--filled.svg": "17f4",
	"./unbabel-sparkles.svg": "3219",
	"./unbabel-subscription.svg": "084e",
	"./unbabel-task-splitting-2.svg": "7ffc",
	"./unbabel-task-splitting.svg": "d9e0",
	"./unbabel-touch-id-lock.svg": "d888",
	"./unbabel-translate--filled.svg": "e2dd",
	"./unbabel-translate.svg": "4ba6",
	"./unbabel-translation-auditing.svg": "79b4",
	"./unbabel-translation-memories.svg": "d454",
	"./unbabel-trusted.svg": "1646",
	"./unlock.svg": "d261",
	"./upload-thick-bottom.svg": "1f23",
	"./user-add--filled.svg": "c05b",
	"./user-add.svg": "b2b1",
	"./user-annotator--filled.svg": "cef0",
	"./user-annotator.svg": "6bdf",
	"./user-confirm--filled.svg": "52c8",
	"./user-confirm.svg": "3211",
	"./user-default--filled.svg": "3d30",
	"./user-default.svg": "21aa",
	"./user-delete--filled.svg": "58fb",
	"./user-delete.svg": "a5ba",
	"./user-edit--filled.svg": "8f19",
	"./user-edit.svg": "d710",
	"./user-editor--filled.svg": "646b",
	"./user-editor.svg": "956c",
	"./user-multiple--filled.svg": "f953",
	"./user-multiple.svg": "245e",
	"./user-protection--filled.svg": "bfe3",
	"./user-protection.svg": "646b9",
	"./user-share--filled.svg": "a720",
	"./user-share.svg": "e9a8",
	"./user-shield--filled.svg": "b886",
	"./user-shield.svg": "19cb",
	"./user-signal.svg": "5b79",
	"./video-player.svg": "fedf",
	"./video.svg": "b651",
	"./voice-id-approved.svg": "b6f7",
	"./voice-id-denied.svg": "1018",
	"./voice-id-smartphone.svg": "0a93",
	"./voice-id-user.svg": "a65d",
	"./voice-id.svg": "2055",
	"./volume.svg": "4adf",
	"./wixanswers_int.svg": "ae80",
	"./wordpress_int.svg": "3333",
	"./youtube.svg": "f2ff",
	"./zendesk_chat_int.svg": "c872",
	"./zendesk_faq_int.svg": "1ecb",
	"./zendesk_int.svg": "2cea",
	"./zoho_int.svg": "9c7c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5f9f";